import React from 'react'
import './version-tip.scss'
import { layerManage, showLayer } from '@/utils/layer'
import { Modal } from '@/components/dialog/modal'
import { getBEMCls } from '@/utils/classname'
import { Row } from 'antd'
import classnames from 'classnames'
import $msg from '@/utils/message'
import { $post } from '@/api'
import StaffSeatPurchaseSheet from '../staff-seat-purchase-sheet/staff-seat-purchase-sheet'

import { StaffTipItemConfig } from '../../constants'

interface VersionTipProps {
    count: number
    title?: string
    showTitle?: boolean
    config: StaffTipItemConfig[]
    canPurchase?: boolean
    canUpgrade?: boolean
}

const VersionTip: React.FC<VersionTipProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('version-tip', ...arg)
    const isPurchaseOnly = !!props.canPurchase && !props.canUpgrade
    const [price, setPrice] = React.useState<number | null>(null)

    React.useEffect(() => {
        if (!props.canPurchase) return
        $post<{ fee_infos: Array<{ price: number; fee_code: number }> }, {}>({
            url: '/valueaddedservices/staffseatpayinfo',
        })
            .then(res => {
                const feeInfo = res.fee_infos[0]
                setPrice(+feeInfo.price)
            })
            .catch(e => $msg('error', e.message || '获取员工位价格失败'))
    }, [props.canPurchase])

    const openPurchaseSheet = () => {
        layerManage.pop()
        showLayer(<StaffSeatPurchaseSheet />)
    }

    const toUpgrade = () => {
        $msg('warning', '请前往零售通进行升级！')
        layerManage.pop()
    }

    const footer = props.canPurchase ? (
        <Row className={cls('footer')}>
            {props.canUpgrade && (
                <>
                    <div className={cls('footer', 'action')} onClick={openPurchaseSheet}>
                        <div className={cls('footer', 'main')}>购买员工位</div>
                        <div className={cls('footer', 'sub')}>¥{price || '-'}/个</div>
                    </div>
                    <div className={cls('footer', 'line')}></div>
                    <div className={cls('footer', 'action-primary')} onClick={toUpgrade}>
                        <div className={cls('footer', 'main')}>去升级</div>
                        <div className={cls('footer', 'sub')}>获得更多员工位</div>
                    </div>
                </>
            )}
            {!props.canUpgrade && (
                <>
                    <div className={cls('footer', 'action')} onClick={() => layerManage.pop()}>
                        <div className={cls('footer', 'main')}>取消</div>
                    </div>
                    <div className={cls('footer', 'line')}></div>
                    <div className={cls('footer', 'action-primary')} onClick={openPurchaseSheet}>
                        <div className={cls('footer', 'main')}>购买员工位</div>
                        <div className={cls('footer', 'sub')}>¥{price || '-'}/个</div>
                    </div>
                </>
            )}
        </Row>
    ) : null

    return (
        <Modal
            type="success"
            isShow
            onClose={() => {
                layerManage.pop()
            }}
            onCancel={() => {
                layerManage.pop()
            }}
            onConfirm={toUpgrade}
            okText="去升级"
            footer={footer}
        >
            {props.showTitle && (
                <div className={cls('title')}>
                    {props.title ||
                        (isPurchaseOnly
                            ? `已达员工数量上限(${props.count}位)，可购买员工位继续添加员工`
                            : props.canPurchase
                            ? `当前员工数量已满${props.count}位，可购买员工位继续添加`
                            : `当前员工数量已满${props.count}位，是否升级为旗舰版？`)}
                </div>
            )}
            {!isPurchaseOnly && (
                <Row
                    style={{
                        borderRadius: '16px',
                        marginBottom: '20px',
                        overflow: 'hidden',
                    }}
                >
                    {props.config.map((config, index) => (
                        <div
                            key={config.count}
                            className={classnames(cls('item'), {
                                [cls('disabled')]: props.count >= (config.limit || config.count),
                            })}
                        >
                            <div className={cls('line', `${index}`)}></div>
                            <div className={cls('item', 'title')}>
                                {config.title || ['标准版', '专业版', '旗舰版'][index]}
                            </div>
                            <div className={cls('item', 'container')}>
                                <div className={cls('item', 'count')}>{config.count}</div>
                                <div className={cls('item', 'unit')}>{config.unit}</div>
                            </div>
                        </div>
                    ))}
                </Row>
            )}
        </Modal>
    )
}

VersionTip.defaultProps = {
    showTitle: true,
}

export default VersionTip
